// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2OxBW","name":"Header_name__1Q4_d","birthday":"Header_birthday__Lkjcc","skeleton":"Header_skeleton__1_kvi"};